import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { COUPONS_PATH } from '../../core/constants';
import { exportBase64File, extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getCouponQRCodeAction = createAsyncThunk(
    'coupon/getCouponQRCodeAction',
    async (id, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ COUPONS_PATH }/${ id }/qr`);
            const fileName = 'Kod_QR';
            const extension = 'png';
            exportBase64File(extractResponseData(response)?.qrCode, fileName, extension);
            return fulfillWithValue();
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getCouponQRCodeSlice = createSlice({
    name: 'getCouponQRCodeSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getCouponQRCodeAction.pending, () => STATE__API__STARTED);
        builder.addCase(getCouponQRCodeAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getCouponQRCodeAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getCouponQRCodeState = (state) => state.coupon.getCouponQRCode;
export default getCouponQRCodeSlice.reducer;